import { CalculationSummaryContainer } from './CalculationSummaryContainer.styled';

import type { FC, ReactNode } from 'react';

interface CalculationSummaryHeaderProps {
  title: string;
  children: string | ReactNode;
}

export const CalculationSummaryHeader: FC<CalculationSummaryHeaderProps> = ({
  title,
  children,
}) => (
  <CalculationSummaryContainer direction="column" alignItems="center" flexWrap="wrap">
    <h6>{title}</h6>
    <h1>{children}</h1>
  </CalculationSummaryContainer>
);
